import { makeAutoObservable } from "mobx";
import {
    deleteRoleEx,
    getRoleExById,
    saveOrUpdate,
    pagingRoleEx
} from 'app/services/RoleExService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { RoleEx } from "app/common/Model/RoleEx";
import { checkSearchObject } from "app/common/LocalFunction";
import { deleteSysFunctionById, getSysFunctionById, pagingSysFunction, saveSysFunction, updateSysFunction } from "app/services/SysFunctionRoleService";

export default class SysFunctionStore {
    listAllSysFunction = [];
    searchSysFunction = new SearchObject();
    pageSysFunction = null;
    selectedSysFunction = {};
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingSysFunction = async () => {
        return await pagingSysFunction(this.searchSysFunction)
            .then(({ data }) => {
                this.pageSysFunction = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchSysFunction) => {
        console.log("searchSysFunction 1:",searchSysFunction);
        
        this.searchSysFunction = checkSearchObject(this.searchSysFunction, searchSysFunction);
        console.log("searchSysFunction:",this.searchSysFunction );
        this.pagingSysFunction();
    }

    handleOpenFormCreateOrEdit = (SysFunctionId) => {
        console.log("id:",SysFunctionId);
        
        if (Boolean(SysFunctionId)) {
            getSysFunctionById(SysFunctionId).then(({ data }) => {
                this.selectedSysFunction = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedSysFunction = {};
            this.openFormCreateOrEdit = true;
        }
    }

    saveSysFunction = (role, { setSubmitting }) => {
        saveSysFunction(role)
            .then(() => {
                this.selectedSysFunction = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingSysFunction();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    updateSysFunction = (id,value, { setSubmitting }) => {
        updateSysFunction(id,value)
            .then(() => {
                this.selectedSysFunction = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingSysFunction();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (role) => {
        this.selectedSysFunction = { id: role?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteSysFunctionById(this.selectedSysFunction?.id)
            .then(() => {
                if (this.searchSysFunction?.pageIndex > 1 && this.pageSysFunction?.content?.length === 1) {
                    this.searchSysFunction.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingSysFunction();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchSysFunction = new SearchObject();
        this.pageSysFunction = null;
        this.selectedSysFunction = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

}
